var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"close":""},on:{"click:close":_vm.emitClose}},[_c('v-avatar',{attrs:{"left":""}},[_c('v-icon',{attrs:{"small":""}},[_vm._v(" mdi-account ")])],1),_vm._v(" "+_vm._s(_vm.contact.Navn)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }